/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 住所マスタ検索情報
 */
export interface Szza018aRequestAddressMasterSearchInfo { 
    /**
     * 住所コードリスト：数字
     */
    addressCodeList?: Array<string> | null;
    /**
     * 適用開始日付(From)：日付(yyyyMMdd)
     */
    applyStartDateFrom?: string | null;
    /**
     * 適用開始日付(To)：日付(yyyyMMdd)
     */
    applyStartDateTo?: string | null;
    /**
     * 適用終了日付(From)：日付(yyyyMMdd)
     */
    applyEndDateFrom?: string | null;
    /**
     * 適用終了日付(To)：日付(yyyyMMdd)
     */
    applyEndDateTo?: string | null;
    /**
     * 郵便番号：数字
     */
    zipCode?: string | null;
    /**
     * 都道府県カナ名：全角（カナ/数字/英字/スペース/記号)
     */
    prefecturesKanaName?: string | null;
    /**
     * 市区郡町村カナ名：全角（カナ/数字/英字/スペース/記号)
     */
    cityKanaName?: string | null;
    /**
     * 町域カナ名：全角（カナ/数字/英字/スペース/記号)
     */
    townAreaKanaName?: string | null;
}

